import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// True below MUI's 'sm' breakpoint (600px, phone-width). Used to switch
// Dialogs to fullScreen on phones — a floating modal with internal scrolling
// is cramped for a form with many fields and makes the submit button
// unreachable once the on-screen keyboard opens; a fullScreen Dialog hands
// the whole viewport to the browser instead, which handles that correctly.
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
